import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { useLocation } from "react-router-dom";

const NotesContent = ({ onChange }) => {
  const [notesContent, setNotesContent] = useState("");

  const [isEdit, setIsEdit] = useState(false);
  const [isEditData, setIsEditData] = useState(null);

  const [base_url] = useState(base_url_from_axios_config);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const handleChange = (notesData) => {
    setNotesContent(notesData);
    onChange(notesData);
  };

  const location = useLocation();

  useEffect(() => {
    if (location.state?.item) {
      // console.log('info edit :',location.state?.item.REG_NO)
      fetchFleetInfo(location.state?.item.REG_NO);
      setIsEditData(location.state.item);
      // setFormData(location.state.item)
      setIsEdit(true);
    }
  }, [location.state]);

  const fetchFleetInfo = async (regNo) => {
    try {
      const apiURL = `${base_url}/api/CpaysCount/${companyCode}/VEHICLEINFO/${regNo}/-`;
      const response = await axios.get(apiURL);

      const notes = response.data[0]?.Notes || "";
      console.log("notes data from regNo edit:", notes);
      setNotesContent(notes);
      onChange(notes);
    } catch (error) {
      console.error("Error whilefetchFleetInfo!:", error);
    }
  };

  return (
    <div>
      <div class="bg-white border border-slate-200 grid grid-cols-6 gap-2 rounded-xl p-2 text-sm">
        <h1 class="text-center text-slate-300 text-xl font-bold col-span-6">
          Notes Content
        </h1>
        <textarea
          value={notesContent || ""}
          onChange={(e) => handleChange(e.target.value)}
          placeholder="Your Notes..."
          class="bg-slate-100 text-slate-600 h-28 placeholder:text-slate-600 placeholder:opacity-50 border border-slate-200 col-span-6 resize-none outline-none rounded-lg p-2 duration-300 focus:border-slate-600"
        ></textarea>
      </div>
    </div>
  );
};

export default NotesContent;
